/**
 * AppRouter is the main router for the
 */
import React, { Component } from "react";
//import ProtectedRoute from "./ProtectedRoute";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

//import { HashRouter as Router } from "react-router-dom";
import Appbar from "../ui/appbar"
import Main from "../functional/main/Main";
//import { Switch } from "../components/ui";
import routes from './Routes'
import PasswordResetForm from '../functional/authentication/signin/ResetPassword';
import ConfirmOTP from '../functional/authentication/verify/ConfirmOTP';
import SignUpContainer from '../functional/authentication/signup/SignUpContainer';
import { CreateAdminContainer } from "../functional/authentication/CreateAdmin";
import { UpdateUserProfileContainer } from "../functional/authentication/updateUserProfile";
import {AddStepperContainer,EditStepperContainer} from '../functional/school'
import { RulesStepperContainer } from '../functional/school/stepper'
import {PricingContainer} from "../functional/pricing/";
import {SubscriptionContainer} from '../functional/subscription'
import OrderHistoryContainer  from '../functional/orderHistory/OrderHistoryContainer'
import ChangePasswordContainer from '../functional/authentication/changePassword/ChangePasswordContainer';
import TimeTableContainer from '../functional/school/timeTable/TimeTableContainer'
import PublicTimeTableContainer from '../functional/publicTimetable/PublicTimeTableContainer'
import MakeOwner from "../functional/makeOwner/MakeOwnerComponent";
class AppRouter extends Component {
    render = () => {
        return (
            <Router>
                <Switch>
                    <Route exact path={routes.main} component={Main} />
                    {/* <Route exact path={routes.register} component={SignUp}/> */}
                    <Route exact path={routes.reset} component={PasswordResetForm} />
                    <Route exact path={routes.confirmOTP} component={ConfirmOTP} />
                    <Route exact path={routes.register} component={SignUpContainer} />
                    <Route exact path={routes.createAdmin} component={CreateAdminContainer} />
                    <Route exact path={routes.profile} component={UpdateUserProfileContainer} />
                    <Route exact path={routes.addSchool} component={AddStepperContainer}/>
                    <Route exact path={routes.editSchool} component={EditStepperContainer}/>
                    <Route exact path={routes.addNewRules} component={RulesStepperContainer}/>
                    <Route exact path={routes.pricing} component={PricingContainer}/>
                    <Route exact path={routes.subscription} component={SubscriptionContainer}/>
                    <Route exact path={routes.changePassword} component={ChangePasswordContainer}/>
                    <Route exact path={routes.timeTable} component={TimeTableContainer}/>
                    <Route exact path={routes.ownerInvite} component ={MakeOwner}/>
                    <Route exact path={routes.publicTimeTable} component={PublicTimeTableContainer} />
                    <Route exact path={routes.orderHistory} component={OrderHistoryContainer} />
                </Switch>
           
            </Router>
        )
    }
}

export default AppRouter;
